module.exports = __webpack_public_path__ + "img/aanleg5.bff406fd.jpg";